

































































































































































































































































import { EditorHelper, NodeType } from '@getaccept/editor-lib';
import { useEditorViewInputStore } from '@getaccept/editor-view/src/store/editor-view-input.store';
import { AttachmentType } from '@getaccept/lib-shared/src/attachments/types/attachment-type';
import type { AuthenticationStepInput } from '@getaccept/lib-shared/src/authentication/types/authentication-step-input';
import type { ChatComment } from '@getaccept/lib-shared/src/chat/types/chat-comment';
import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import { FieldPlacementHelper } from '@getaccept/lib-shared/src/fields/helpers/field-placement.helper';
import { FieldHelper } from '@getaccept/lib-shared/src/fields/helpers/field.helper';
import { FieldType } from '@getaccept/lib-shared/src/fields/types/enums/field-type';
import type { Field } from '@getaccept/lib-shared/src/fields/types/field';
import { throttle } from '@getaccept/lib-shared/src/helpers';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import ReviewChangesModal from '@getaccept/lib-shared/src/prompt-bar/ReviewChangesModal.vue';
import RevisionPromptBar from '@getaccept/lib-shared/src/prompt-bar/RevisionPromptBar.vue';
import { RecipientRole } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-role';
import { RecipientStatus } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-status';
import { SigningHelper as SigningShared } from '@getaccept/lib-shared/src/signature/helpers/signing.helper';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import { useToast } from '@getaccept/lib-shared/src/toast';
import type { NodeTrackingPayload } from '@getaccept/lib-shared/src/tracking/types/node-tracking-payload';
import { TrackingType } from '@getaccept/lib-shared/src/tracking/types/tracking-type';
import type { DocumentAttachment } from '@getaccept/lib-shared/src/types/document-attachment';
import type { DocumentPage } from '@getaccept/lib-shared/src/types/document-page';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { SigningPageVideo } from '@getaccept/lib-shared/src/types/signing-page-video';
import EngageVideo from '@getaccept/lib-shared/src/video/player/components/EngageVideo.vue';
import type { Channel } from '@getaccept/pusher';
import { DocumentEvent as DocumentPusherEvent, RecipientEvent } from '@getaccept/pusher';
import {
  computed,
  defineComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import printJS from 'print-js';
import TrackingService from '../api/tracking/services/tracking.service';
import Chat from '../chat/components/Chat.vue';
import { useChatStore } from '../chat/store/chat.store';
import { isPopupBlocked } from '../common/utils/window';
import { reviewTimerDuration } from '../documents/constants/review-timer-duration';
import { useDocumentStore } from '../documents/store/document.store';
import { DocumentEvent } from '../documents/types/enums/document-event';
import { useEntityStore } from '../entity/store/entity.store';
import { useFieldsStore } from '../fields/store/fields.store';
import { PageHelper } from '../helpers/page.helper';
import { RecipientHelper } from '../helpers/recipient.helper';
import { RevisionHelper } from '../helpers/revision.helper';
import AuthorizeNet from '../integrations/authorizenet/components/AuthorizeNet.vue';
import { useAuthorizeNet } from '../integrations/authorizenet/composables/authorize-net.composable';
import Stripe from '../integrations/stripe/components/Stripe.vue';
import { useStripe } from '../integrations/stripe/composables/stripe.composable';
import PhoneModal from '../integrations/twilio/components/PhoneModal.vue';
import { pusherClient } from '../pusher';
import { usePusherStore } from '../pusher/store/pusher.store';
import RecipientsModal from '../recipients/components/RecipientsModal.vue';
import { useSessionStore } from '../session/store/session.store';
import BottomBar from '../signing/bottom-bar/components/BottomBar.vue';
import DocumentContainer from '../signing/components/DocumentContainer.vue';
import SignActions from '../signing/components/SignActions.vue';
import UnsupportedBrowserModal from '../signing/components/UnsupportedBrowserModal.vue';
import ApproveModal from '../signing/components/modals/ApproveModal.vue';
import EditAfterSentMobileModal from '../signing/components/modals/EditAfterSentMobileModal.vue';
import InitialsModal from '../signing/components/modals/InitialsModal.vue';
import InviteModal from '../signing/components/modals/InviteModal.vue';
import RejectModal from '../signing/components/modals/RejectModal.vue';
import SignModal from '../signing/components/modals/SignModal.vue';
import { SigningHelper } from '../signing/helpers/signing.helper';
import { useSigningStore } from '../signing/store/signing.store';
import DocumentUpdatedPromptBar from '../signing/top-bar/components/DocumentUpdatedPromptBar.vue';
import DownloadingPromptBar from '../signing/top-bar/components/DownloadingPromptBar.vue';
import PreviewBar from '../signing/top-bar/components/PreviewBar.vue';
import SigningPageTopBar from '../signing/top-bar/components/SigningPageTopBar.vue';
import { SigningStep as ESigningStep } from '../signing/types/enums/signing-step';
import type { InviteRecipientInfo } from '../signing/types/invite-recipient-info';
import UploadAttachmentModal from '../signing/upload-attachment/components/UploadAttachmentModal.vue';
import store from '../store/root.store';
import { RootAction } from '../store/root.types';
import * as supportedBrowsersRegExp from '../supported-browsers-reg-exp.js';
import { useThemeStore } from '../theme/theme.store';
import TrackVisitTimes from '../tracking/components/TrackVisitTimes.vue';
import { TrackingConstants } from '../tracking/constants/tracking';
import { TrackingHelper } from '../tracking/helpers/tracking.helper';
import VideoReminder from '../video/components/VideoReminder.vue';

export default defineComponent({
  components: {
    Chat,
    SigningPageTopBar,
    BottomBar,
    SignActions,
    UnsupportedBrowserModal,
    DocumentContainer,
    RecipientsModal,
    EngageVideo,
    RejectModal,
    SignModal,
    ApproveModal,
    InviteModal,
    Stripe,
    AuthorizeNet,
    PhoneModal,
    VideoReminder,
    InitialsModal,
    ReviewChangesModal,
    DownloadingPromptBar,
    RevisionPromptBar,
    DocumentUpdatedPromptBar,
    UploadAttachmentModal,
    TrackVisitTimes,
    PreviewBar,
    EditAfterSentMobileModal,
  },
  setup() {
    const recipientId = computed(() => store.state.recipientId);
    const authId = computed(() => store.state.authId);
    const isPreview = computed(() => store.state.isPreview);
    const pusherConnected = computed(() => store.state.pusherConnected);
    const videoReminderId = computed(() => store.state.videoReminderId);

    const setPreviewExpired = (expired: boolean) => {
      store.dispatch(RootAction.SetPreviewExpired, expired);
    };

    const sessionStore = useSessionStore();
    const { token, recipientFirstOpen } = storeToRefs(sessionStore);

    const setSessionStatus = (status: DocumentStatus) => {
      sessionStore.setStatus(status);
    };

    const setToken = (payload: {
      token: {
        jwt: string;
        exp: number;
      };
      authStepsInput: AuthenticationStepInput[];
    }) => {
      sessionStore.loadTokenSuccess(payload.token, payload.authStepsInput);
    };

    const signingStore = useSigningStore();

    const {
      initials,
      step,
      selectedInitialFieldId,
      bankId,
      selectedEid,
      criiptoStatus,
    } = storeToRefs(signingStore);

    const actionCancelBankIdTransaction = (ssn: string) => {
      signingStore.cancelBankIdTransaction(ssn);
    };

    const actionApproveDocument = () => {
      signingStore.approveDocument();
    };

    const addInitials = (payload: { initials: string; fieldId: string }) => {
      signingStore.addInitials(payload.initials);
      fieldsStore.addVerifiedInitialId(payload.fieldId);
    };

    const setSelectedInitialFieldId = (selectedInitialFieldId: string) => {
      signingStore.setSelectedInitialFieldId(selectedInitialFieldId);
    };

    const resetSigningState = () => {
      signingStore.resetState();
    };

    const verifySignature = async ({
      signatureBase30,
      signatureBase64,
    }: {
      signatureBase30: string;
      signatureBase64: string;
    }) => {
      await signingStore.verifySignature(signatureBase30, signatureBase64);
    };

    const checkVerificationStep = async () => {
      await signingStore.checkVerificationStep();
    };

    const chatStore = useChatStore();
    const {
      comments,
      commentsRead,
      isOpen: isChatOpen,
      systemMessageOpen: chatSystemMessageOpen,
    } = storeToRefs(chatStore);

    const actionLoadChat = async (entity: Entity) => {
      await chatStore.loadChat(entity, document.value, currentRecipient.value);
    };

    const actionReadComments = () => {
      chatStore.readComments();
    };

    const actionSetChatSystemMessageOpen = (open: boolean) => {
      chatStore.setSystemMessageOpen(open);
    };

    const numUnreadComments = computed((): number => {
      let othersComments: ChatComment[];
      if (recipientId.value) {
        othersComments = comments.value.filter(
          (comment: ChatComment) => comment.recipientId !== recipientId.value
        );
      } else {
        othersComments = comments.value;
      }

      const commentsReadIds: string[] = commentsRead.value
        ? commentsRead.value.map((comment: ChatComment) => comment.id)
        : [];

      return othersComments.filter((comment: ChatComment) => !commentsReadIds.includes(comment.id))
        .length;
    });

    const documentStore = useDocumentStore();
    const {
      isLoading,
      isEditorRecipientInputLoading,
      revisionsIsLoading,
      partiallySignedFields,
      revisionsViewedLoading,
      isButtonLoading,
      forwarded,
      pdfUrl,
      isDownloading,
      focusedRequiredId,
      document,
      editorRecipientInput,
    } = storeToRefs(documentStore);

    const actionLoadAfterSign = async () => {
      await documentStore.loadDocument();
      fieldsStore.load();
    };

    const sendEventLog = (event: DocumentEvent) => {
      documentStore.sendEventLog(event, recipientId.value, authId.value);
    };

    const loadDocument = async () => {
      await documentStore.loadDocument();
    };

    const loadDocumentRevisions = async () => {
      await documentStore.loadDocumentRevisions();
    };

    const actionSetEditorRecipientInput = (editorRecipientInput: EditorRecipientInput[]) => {
      documentStore.setEditorRecipientInput(editorRecipientInput);
    };

    const setDocumentStatus = (status: DocumentStatus) => {
      documentStore.setDocumentStatus(status);
    };

    const recipientsTurnToSign = computed(
      (): SigningPageRecipient => {
        if (!document.value?.recipients || !document.value.nextRecipientIdToSign) {
          return;
        }
        return document.value.recipients.find(
          (recipient: SigningPageRecipient) => recipient.id === document.value.nextRecipientIdToSign
        );
      }
    );

    const myTurnToSign = computed((): boolean => {
      if (!currentRecipient.value) {
        return false;
      }

      if (!document.value?.isSigningOrder) {
        return SigningHelper.isSigningTurnNoSigningOrder(currentRecipient.value);
      }

      return SigningHelper.isSigningTurnSigningOrder(
        recipientId.value,
        document.value.nextRecipientsInLine
      );
    });

    const currentRecipient = computed(
      (): SigningPageRecipient => {
        if (!recipientId.value || !document.value || !document.value.recipients) {
          return;
        }
        return document.value.recipients.find(
          (recipient: SigningPageRecipient) => recipient.id === recipientId.value
        );
      }
    );

    const getterVideoReminder = computed(
      (): SigningPageVideo => {
        if (!videoReminderId.value) {
          return null;
        }
        if (!document.value.documentVideos?.length) {
          return null;
        }
        return document.value.documentVideos.find(
          (documentVideo: SigningPageVideo) => documentVideo.id === videoReminderId.value
        );
      }
    );

    const viewableRecipients = computed((): SigningPageRecipient[] => {
      if (!document.value?.recipients) {
        return [];
      }
      if (isPreview.value) {
        return document.value.recipients;
      }

      return RecipientHelper.getViewableRecipients(
        currentRecipient.value,
        document.value.recipients
      );
    });

    const fieldsStore = useFieldsStore();
    const { pageWidth, verifiedInitialFieldIds, fields: stateFields } = storeToRefs(fieldsStore);

    const fields = computed((): Field[] =>
      stateFields.value.map((field: Field) => ({
        ...field,
        position: FieldPlacementHelper.calculateFieldPositionForPlacement(
          field.position,
          pageWidth.value
        ),
      }))
    );

    const hasReceivedPusherNotification = ref(false);

    const themeStore = useThemeStore();
    const { theme } = storeToRefs(themeStore);
    const { toast } = useToast();
    const isEngageVideoOpen = ref(false);
    const interactionTimer = ref(null);
    const showRejectModal = ref(false);
    const pageImageLoaded = ref(false);
    const showBrowserPrompt = ref(false);
    const uploadAttachmentData = ref({
      show: false,
      name: '',
      id: '',
    });

    const commentsOpen = ref(false);
    const showSigningModal = ref(false);
    const showInviteModal = ref(false);
    const showApproveModal = ref(false);
    const showStripeModal = ref(false);
    const showAuthorizeNetModal = ref(false);
    const showRecipientsModal = ref(false);
    const showPhoneModal = ref(false);
    const showVideoReminder = ref(false);
    const isPrinting = ref(false);
    const showReviewChangesModal = ref(false);
    const showRevisionPromptBar = ref(false);
    const waitingToShowReviewModal = ref(false);
    const forcedReviewTimer = ref(20);
    const showDocumentUpdatedPromptBar = ref(false);
    const debouncedResetInteractionTimer: () => void = throttle(
      () => resetInteractionTimer(),
      1000
    );
    const trackingDisabled = ref(true);
    const userIsInactive = ref(false);
    const pagesInViewport = ref<DocumentPage[]>([]);

    const { stripe, loadStripe } = useStripe();
    const authorizeNet = useAuthorizeNet();
    const entityStore = useEntityStore();
    const { entity } = storeToRefs(entityStore);
    const { isXSmallScreenAndDown, isSmallScreenAndDown } = useBreakpoints();

    const stripeIntegration = computed(() => stripe.value);
    const authorizeNetIntegration = computed(() => authorizeNet.authorizeNet.value);

    const updateDocumentRevisions = async () => {
      if (
        latestSealedRevision.value &&
        !latestSealedRevision.value.viewedByRecipient &&
        document.value?.documentRevisions?.length !== 1
      ) {
        if (!isPreview.value) {
          showReviewChangesModal.value = true;
          await documentStore.setRevisionViewedByRecipient(latestSealedRevision.value.revision);
        }
        await loadDocumentRevisions();
      }
    };

    watch(document, updateDocumentRevisions);

    const { recipientChannel: recipientPusherChannel, documentChannel } = storeToRefs(
      usePusherStore()
    );

    const addPusherSubscriptions = async () => {
      pusherClient.listen(
        recipientPusherChannel.value as Channel,
        RecipientEvent.DownloadDocumentResponse,
        ({ url }: { url: string }) => {
          if (isPrinting.value) {
            prepareForPrint(url);
          } else if (isDownloading.value) {
            handleDownloadComplete(url);
          }
          documentStore.downloadDocumentComplete();
        }
      );
      pusherClient.listen(
        documentChannel.value as Channel,
        DocumentPusherEvent.Sealed,
        (sealed: { documentId: string; entityId: string; revision: number }) => {
          if (sealed && document.value) {
            handleNewRevisionPushed(reviewTimerDuration);
          }
        }
      );
      pusherClient.listen(
        documentChannel.value as Channel,
        DocumentPusherEvent.DocumentUpdated,
        () => (showDocumentUpdatedPromptBar.value = true)
      );
      pusherClient.listen(documentChannel.value as Channel, DocumentPusherEvent.Comment, () => {
        hasReceivedPusherNotification.value = true;
        actionLoadChat(entity.value);
      });
      pusherClient.listen(
        documentChannel.value as Channel,
        DocumentPusherEvent.Signed,
        async () => {
          resetSigningState();
          await actionLoadAfterSign();
          documentStore.loadPartiallySignedFields();
          setTimeout(() => {
            handleToggleStripe(true);
            handleToggleAuthorizeNet(true);
          }, 3000);
        }
      );
    };

    const subscribePusher = (pusherConnected: boolean) => {
      if (pusherConnected) {
        addPusherSubscriptions();
      }
    };

    watch(pusherConnected, subscribePusher, { immediate: true });

    const toggleTracking = () => {
      if (
        TrackingHelper.allowedTrackingRecipientStatus(currentRecipient.value?.status) &&
        !isPreview.value &&
        document.value.status !== DocumentStatus.Signed
      ) {
        trackingDisabled.value = false;
      } else {
        trackingDisabled.value = true;
      }
    };

    watch(currentRecipient, toggleTracking);
    watch(() => document.value?.status, toggleTracking);

    const handleWatchNumUnreadComments = () => {
      if (shouldPopChat.value) {
        handleToggleChat();
      } else if (isChatOpen.value) {
        actionReadComments();
      }
    };

    watch(numUnreadComments, handleWatchNumUnreadComments);

    const classes = computed(() => ({
      'is-preview': !showNewTopBar.value && isPreview.value,
      'prompt-bar-padding': !showNewTopBar.value && showPromptBar.value,
      'preview-bar-visible': showNewTopBar.value && isPreview.value,
      'prompt-bar-visible': showNewTopBar.value && showPromptBar.value,
      'no-scroll': isChatOpen.value,
      'hide-bottom-bar': !isSignActionAllowed.value,
    }));

    const shouldPopStripe = computed(() => stripeIntegration.value && !!document.value.value);

    const loadPreviewData = async () => {
      await loadDocument();
      openEngageVideoAutomatic();
      fieldsStore.load();
    };

    const handleReject = (reason: string) => {
      handleUpdateDocumentStatus(DocumentStatus.Rejected);
      documentStore.rejectDocument(reason, recipientId.value, document.value.id, authId.value);
    };

    const handleUpdateDocumentStatus = (status: DocumentStatus) => {
      if (isPreview.value) {
        return;
      }
      documentStore.sendDocumentStatus(status, recipientId.value, authId.value);
    };

    const editorViewInputStore = useEditorViewInputStore();
    const { updatingInputs, hasFormInputFieldsWithErrors } = storeToRefs(editorViewInputStore);

    const loadingRecipientInput = computed(() => !!updatingInputs.value.length);

    const showPromptBar = computed(
      () => showRevisionPromptBar.value || isDownloading.value || showDocumentUpdatedPromptBar.value
    );

    const shouldPopChat = computed(
      () =>
        numUnreadComments.value > 0 &&
        !isChatOpen.value &&
        !isSmallScreenAndDown.value &&
        comments.value.length === 1 &&
        isAutoComment.value
    );

    const sortedAttachments = computed(() =>
      [...document.value.documentAttachments].sort(
        (a: DocumentAttachment, b: DocumentAttachment) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
      )
    );

    const viewportIsObscured = computed(
      () =>
        (isChatOpen.value && isSmallScreenAndDown.value) ||
        showEngageVideo.value ||
        showSigningModal.value ||
        showRecipientsModal.value ||
        showRejectModal.value ||
        showUploadAttachmentModal.value ||
        showApproveModal.value ||
        showPhoneModal.value ||
        showInviteModal.value ||
        showVideoReminder.value
    );

    const canInvite = computed(() => recipient.value?.role !== RecipientRole.Approver);
    const shouldStartEid = computed(() => shouldStartCriipto.value || shouldStartBankId.value);
    const shouldStartCriipto = computed(() => !!criiptoStatus.value && !!selectedEid.value?.key);
    const shouldStartBankId = computed(() => !!bankId.value?.orderRef);

    const chatEnabled = computed(
      () =>
        !!entity.value &&
        !entity.value.isDisableComment &&
        recipient.value?.role !== RecipientRole.Approver
    );

    const showLoader = computed(() => {
      if (isPreview.value) {
        return isLoading.value;
      }
      return isLoading.value || isEditorRecipientInputLoading.value;
    });

    const documentExtractable = computed(() => entity.value && !!entity.value.documentDownload);

    const allRecipients = computed(() => viewableRecipients.value);
    const sender = computed(() => document.value?.user);

    const currentRecipientsTurnToSign = computed(
      () => document.value && document.value.nextRecipientIdToSign === recipientId.value
    );

    const documentPages = computed(() => {
      if (documentManuallySigned.value) {
        return [];
      }
      const mappedFields: Field[] = sortedFields.value.map((field: Field) =>
        SigningHelper.mappedFields(field, document.value, entity.value)
      );
      return PageHelper.getPagesWithFields(document.value.pages, mappedFields);
    });

    const documentManuallySigned = computed(() => !!document.value?.manuallySignedPages?.length);

    const manuallySignedPages = computed(() => {
      if (documentManuallySigned.value) {
        return document.value.manuallySignedPages;
      }
      return [];
    });

    const recipient = computed(() =>
      allRecipients.value.find(
        (recipient: SigningPageRecipient) => recipient.id === recipientId.value
      )
    );

    const isSignActionAllowed = computed(() => {
      if (isPreview.value || !recipient.value || !document.value?.isSigning) {
        return false;
      }
      return !SigningShared.hasRecipientSigned(recipient.value.status);
    });

    const videoUrl = computed(() => document.value?.video?.videoUrl);
    const videoId = computed(() => document.value?.video?.id);
    const videoThumbnail = computed(() => document.value?.video?.thumbUrl);
    const reminderExpirationDays = computed(() => entity.value?.reminderExpirationDays);
    const requiredStepsLeft = computed(() => requiredIds.value?.length > 0);

    const requiredIds = computed(() => {
      if (!isSignActionAllowed.value) {
        return [];
      }

      const requiredFields: Field[] = fields.value.filter(isRequiredField);
      const emptyRequiredEditorFields = EditorHelper.getEmptyFormFieldsAssignedToRecipient(
        EditorHelper.getEditorFormMergeFields(documentPages.value),
        EditorHelper.getAllRequiredEditorFields(document.value as any, [NodeType.Form]),
        editorRecipientInput.value,
        currentRecipient.value?.id
      );

      const emptyRequiredEditorSignatureFields = EditorHelper.getEmptySignatureFieldsAssignedToRecipient(
        EditorHelper.getAllRequiredEditorFields(document.value as any, [NodeType.Signature]),
        currentRecipient.value?.id,
        partiallySignedFields.value
      );
      const fieldsSortedByPosition: (Field & { pageNum: number })[] = FieldHelper.sortByPosition(
        requiredFields,
        documentPages.value
      );
      const requiredAttachments = document.value.documentAttachments.filter(
        (attachment: DocumentAttachment) => {
          if (attachment.attachment.type === AttachmentType.Upload) {
            return attachment.requireView && !attachment.lastUpload;
          }
          return attachment.requireView && !attachment.lastView;
        }
      );
      const allEditorFields = EditorHelper.getAllRequiredEditorFields(document.value as any, [
        NodeType.Signature,
        NodeType.Form,
      ]);
      const sortedEmptyEditorFields = [
        ...emptyRequiredEditorFields,
        ...emptyRequiredEditorSignatureFields,
      ].sort(
        (a, b) =>
          allEditorFields.findIndex(field => field.id === a.id) -
          allEditorFields.findIndex(field => field.id === b.id)
      );

      const fieldsAndEditorFieldsSortedByPageNum = [
        ...fieldsSortedByPosition,
        ...sortedEmptyEditorFields,
      ].sort((a, b) => a.pageNum - b.pageNum);

      return [
        ...fieldsAndEditorFieldsSortedByPageNum.map(field => field.id),
        ...requiredAttachments.map((attachment: DocumentAttachment) => attachment.id),
      ];
    });

    const isRequiredField = (field: Field): boolean => {
      if (field.recipientId !== recipientId.value) {
        return false;
      }
      const isEmptyInitialsField: boolean =
        field.type === FieldType.Initials && !verifiedInitialFieldIds.value.includes(field.id);

      const isEmptyRequiredField: boolean = !field.value && field.isRequired;

      return isEmptyRequiredField || isEmptyInitialsField || isInvalidFieldValue(field);
    };

    const nextRequiredId = computed(
      () =>
        (requiredIds.value &&
          requiredIds.value[requiredIds.value.indexOf(focusedRequiredId.value) + 1]) ||
        requiredIds.value[0] ||
        null
    );

    const isInvalidFieldValue = (field: Field): boolean => {
      if (field.type === FieldType.Text && field.isRequired) {
        return !field.value?.trim();
      }
      if (field.type === FieldType.Formatted && field.value) {
        const validFieldValue: boolean =
          !!field.value.trim() && new RegExp(field.validationRegex).test(field.value);
        return !validFieldValue;
      }
      return false;
    };

    const sortedFields = computed(
      () => FieldHelper.sortByPosition(fields.value, document.value.pages) || []
    );

    const activeTwilioIntegration = computed(() => document.value?.activeTwilioIntegration);
    const documentLogoUrl = computed(() => BrandingHelper.getLogoUrl(theme.value));

    const showEngageVideo = computed(() => {
      if (!document.value || !document.value.isVideo) {
        return false;
      }
      return isEngageVideoOpen.value;
    });

    const showUploadAttachmentModal = computed(() => uploadAttachmentData.value?.show);
    const isSigningEnabled = computed(() => myTurnToSign.value);
    const emptyBottomBar = computed(
      () => isPreview.value || recipient.value?.role === RecipientRole.CC
    );

    const showReject = computed(
      () =>
        !isPreview.value &&
        isSigningEnabled.value &&
        pageImageLoaded.value &&
        !hasRecipientSigned.value
    );

    const hasRecipientSigned = computed(() =>
      recipient.value.role === RecipientRole.Signer
        ? recipient.value.status === RecipientStatus.Signed
        : recipient.value.status === RecipientStatus.Approved
    );

    const latestSealedRevision = computed(() =>
      RevisionHelper.getLatestSealedRevision(document.value?.documentRevisions)
    );

    const documentName = computed(() => document.value?.name);
    const senderFullName = computed(() => document.value?.user?.fullName);
    const reviewLoading = computed(() => revisionsIsLoading.value || revisionsViewedLoading.value);

    const reviewPending = computed(
      () =>
        (document.value?.documentRevisions?.length > 1 &&
          !latestSealedRevision.value.viewedByRecipient) ||
        waitingToShowReviewModal.value
    );

    const showNewTopBar = computed(
      () =>
        // temporary switch to be able to quickly revert to old top bar if needed
        true
    );

    const hasContextualCommenting = computed(() => entity.value?.settings?.contextualCommenting);

    const commentingAllowed = computed(() => {
      if (!document.value) {
        return false;
      }
      return [
        DocumentStatus.Sent,
        DocumentStatus.Viewed,
        DocumentStatus.Reviewed,
        DocumentStatus.Sealed,
      ].includes(document.value.status);
    });

    const toggleShowVideoReminder = (show: boolean) => {
      showVideoReminder.value = show;
    };

    const openEngageVideoAutomatic = () => {
      if (
        recipientFirstOpen.value &&
        document.value &&
        document.value.status !== DocumentStatus.Rejected &&
        document.value.status !== DocumentStatus.Lost &&
        document.value.isVideo
      ) {
        isEngageVideoOpen.value = true;
      }
    };

    const handleImageLoaded = () => {
      pageImageLoaded.value = true;
      setScrollToBottomListener();
    };

    const setScrollToBottomListener = () => {
      if (
        isPreview.value ||
        [RecipientStatus.Reviewed, RecipientStatus.Signed, RecipientStatus.Approved].includes(
          recipient.value.status
        )
      ) {
        return;
      }
      checkScrolledToBottom();
      window.addEventListener('scroll', checkScrolledToBottom, { passive: true });
    };

    const handleToggleChat = () => {
      if (chatSystemMessageOpen.value) {
        actionSetChatSystemMessageOpen(false);
      }
      chatStore.setIsOpen(!isChatOpen.value);
    };

    const handleUpdateRecipientStatus = (status: RecipientStatus) => {
      documentStore.setRecipientStatus(status, recipientId.value, authId.value);
    };

    const handleUpdateFocusedRequiredId = (id: string) => {
      if (focusedRequiredId.value === id) {
        documentStore.setFocusedRequiredId(null);
        nextTick(() => {
          documentStore.setFocusedRequiredId(id);
        });
      } else {
        documentStore.setFocusedRequiredId(id);
      }
    };

    const handleClickSignField = () => {
      if (
        [RecipientStatus.Viewed, RecipientStatus.Reviewed].includes(recipient.value.status) &&
        recipient.value.role === RecipientRole.Signer
      ) {
        handleToggleSigningModal(true);
      }
    };

    const trackNodeClick = async (tracking: Partial<NodeTrackingPayload>) => {
      if (trackingDisabled.value) {
        return;
      }
      const payload = {
        ...tracking,
        revision: latestSealedRevision.value.revision,
        type: TrackingType.NodeClick,
      };
      try {
        await TrackingService.trackEditor([], [payload as NodeTrackingPayload]);
      } catch (_) {
        console.log(`Failed to track click for node with id ${payload.nodeId}`);
      }
    };

    const handleVideoIntro = () => {
      isEngageVideoOpen.value = true;
    };

    const handleCurrentPages = (pageIds: string[]) => {
      pagesInViewport.value = document.value.pages.filter((page: DocumentPage) =>
        pageIds.find(pageId => pageId === page.id)
      );
    };

    const handleUpdateField = ({ fieldId, value }: { fieldId: string; value: string }) => {
      fieldsStore.updateValue(fieldId, value);
    };

    const handleUpdatePageWidth = (offsetWidth: number) => {
      fieldsStore.updatePageWidth(offsetWidth);
    };

    const handleToggleUploadAttachmentModal = (
      payload: { attachmentId: string; name: string },
      show: boolean
    ) => {
      if (show) {
        uploadAttachmentData.value = {
          id: payload.attachmentId,
          name: payload.name,
          show,
        };
      } else {
        uploadAttachmentData.value = {
          id: '',
          name: '',
          show,
        };
      }
    };

    const handleAttachmentUploaded = () => {
      documentStore.loadDocumentAttachments();
      handleToggleUploadAttachmentModal(null, false);
    };

    const resetInteractionTimer = () => {
      if (interactionTimer.value) {
        clearTimeout(interactionTimer.value);
        interactionTimer.value = null;
      }
      userIsInactive.value = false;
      interactionTimer.value = setTimeout(() => {
        userIsInactive.value = true;
      }, TrackingConstants.idleInteractionInterval);
    };

    const handleCloseSystemMessage = () => {
      actionSetChatSystemMessageOpen(false);
    };

    const handleReload = () => {
      window.location.reload();
    };

    const isAutoComment = computed(() => {
      if (document.value.isAutoComment === -1) {
        return !!entity.value.isAutoComment;
      }

      return !!document.value.isAutoComment;
    });

    const isSigningForward = computed(() => !!document.value.isSigningForward);

    const shouldToggleChat = computed(
      () =>
        !isChatOpen.value &&
        !isSmallScreenAndDown.value &&
        comments.value.length === 1 &&
        isAutoComment.value
    );

    const automaticChatMessage = () => {
      if (!recipientFirstOpen.value) {
        return;
      }
      setTimeout(() => {
        if (hasReceivedPusherNotification.value) {
          if (shouldToggleChat.value) {
            handleToggleChat();
          } else if (isChatOpen.value) {
            actionReadComments();
          }
        } else {
          actionSetChatSystemMessageOpen(true);
        }
        sessionStore.setRecipientFirstOpen(false);
      }, 10000);
    };

    const loadData = async () => {
      await Promise.all([loadDocument(), documentStore.loadEditorRecipientInput()]);
      await documentStore.loadPartiallySignedFields();
      await loadStripe();
      await authorizeNet.loadAuthorizeNet();
      if (getterVideoReminder.value) {
        toggleShowVideoReminder(true);
      } else {
        openEngageVideoAutomatic();
      }
      await fieldsStore.load();
      await actionLoadChat(entity.value);
      if (document.value && !document.value.isVideo) {
        automaticChatMessage();
      }
    };

    const handleDownloadComplete = (url: string) => {
      sendEventLog(DocumentEvent.Downloaded);
      const newWindow: Window = window.open(url, '_blank');
      if (isPopupBlocked(newWindow)) {
        handleDownloadCompleteFallback(url);
      }
    };

    const handleDownloadCompleteFallback = (url: string) => {
      const link = window.document.createElement('a');
      link.href = url;
      window.document.body.appendChild(link);
      link.click();
      link.remove();
    };

    const handleNewRevisionPushed = (timerDuration: number) => {
      showRevisionPromptBar.value = true;
      startForcedReviewTimer(timerDuration);
      waitingToShowReviewModal.value = true;
      setTimeout(() => {
        if (waitingToShowReviewModal.value) {
          hideModals();
          loadDocumentRevisions();
          waitingToShowReviewModal.value = false;
          showReviewChangesModal.value = true;
        }
      }, timerDuration);
    };

    const handleShowReviewChangesModal = () => {
      waitingToShowReviewModal.value = false;
      loadDocumentRevisions();
      showRevisionPromptBar.value = false;
      showReviewChangesModal.value = true;
    };

    const handleReviewChanges = async () => {
      forcedReviewTimer.value = 20;
      loadDocumentRevisions();
      if (!latestSealedRevision.value.viewedByRecipient) {
        if (!isPreview.value) {
          await documentStore.setRevisionViewedByRecipient(latestSealedRevision.value.revision);
        }
        loadData();
      }
      showReviewChangesModal.value = false;
    };

    const handlePartiallySign = async ({
      signatureBase64,
      signatureBase30,
      nodeId,
    }: {
      signatureBase64: string;
      signatureBase30: string;
      nodeId: string;
    }) => {
      await checkVerificationStep();
      if (signatureBase30 && step.value.type === ESigningStep.Biometric) {
        await verifySignature({ signatureBase64, signatureBase30 });
      }
      await editorViewInputStore.partiallySignField({
        signature: signatureBase64,
        nodeId: nodeId,
      });
      documentStore.loadPartiallySignedFields();
      documentStore.loadRecipients();
    };

    const startForcedReviewTimer = (duration: number) => {
      let timeLeft = duration / 1000;
      const timer = setInterval(() => {
        if (timeLeft === 0 || !waitingToShowReviewModal.value) {
          clearInterval(timer);
        } else {
          timeLeft -= 1;
        }
        setForcedReviewTimer(timeLeft);
      }, 1000);
    };

    const setForcedReviewTimer = (timeLeft: number) => {
      forcedReviewTimer.value = timeLeft;
    };

    const hideModals = () => {
      showSigningModal.value = false;
      showInviteModal.value = false;
      showApproveModal.value = false;
      showStripeModal.value = false;
      showAuthorizeNetModal.value = false;
      showRecipientsModal.value = false;
      showRevisionPromptBar.value = false;
    };

    const created = () => {
      hideModals();
    };

    created();

    onMounted(async () => {
      window.addEventListener('blur', () => (userIsInactive.value = true));
      window.addEventListener('focus', () => (userIsInactive.value = false));
      window.addEventListener('mousemove', debouncedResetInteractionTimer, true);
      window.addEventListener('scroll', debouncedResetInteractionTimer, true);
      window.addEventListener('afterprint', printPrompt);

      if (isPreview.value) {
        await loadPreviewData();
      } else {
        await loadData();
        resetInteractionTimer();
      }
      checkBrowserSupport();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('blur', () => (userIsInactive.value = true));
      window.removeEventListener('focus', () => (userIsInactive.value = false));
      window.removeEventListener('mousemove', debouncedResetInteractionTimer, true);
      window.removeEventListener('scroll', debouncedResetInteractionTimer, true);
      window.removeEventListener('afterprint', printPrompt);
      window.removeEventListener('scroll', checkScrolledToBottom);
    });

    const handleDownloadDocument = async () => {
      if (document.value.status === DocumentStatus.Signed) {
        await documentStore.getPdfUrl();
        handleDownloadComplete(pdfUrl.value);
      } else if (!isDownloading.value) {
        documentStore.downloadDocument();
      }
    };

    const handlePrint = () => {
      isPrinting.value = true;
      documentStore.downloadDocument();
    };

    const prepareForPrint = (printUrl: string) => {
      const req = new XMLHttpRequest();
      req.open('GET', printUrl, true);
      req.responseType = 'blob';
      req.onload = printDocument;
      req.send();
    };

    const printDocument = ({ target }: ProgressEvent) => {
      const blob = (target as XMLHttpRequest).response;
      const dataUrl = window.URL.createObjectURL(blob);

      try {
        printJS(dataUrl);
        sendEventLog(DocumentEvent.Printed);
      } catch (e) {
        toast.info(t('printer-not-found'));
      }
      isPrinting.value = false;
    };

    const printPrompt = () => {
      toast.info(t('please-use-print-button'));
    };

    const sendMessage = (text: string) => {
      chatStore.addComment(text, recipientId.value, authId.value, document.value.id);
    };

    const checkBrowserSupport = () => {
      showBrowserPrompt.value = !new RegExp(supportedBrowsersRegExp).test(navigator.userAgent);
    };

    const hideBrowserPrompt = () => {
      showBrowserPrompt.value = false;
    };

    const handleOpenRecipients = () => {
      showRecipientsModal.value = true;
    };

    const handleOpenPhoneModal = () => {
      showPhoneModal.value = true;
    };

    const handleClosePhoneModal = () => {
      showPhoneModal.value = false;
    };

    const handleCloseEngageVideo = () => {
      automaticChatMessage();
      isEngageVideoOpen.value = false;
    };

    const handleToggleStripe = (visible: boolean) => {
      if (shouldPopStripe.value) {
        showSigningModal.value = false;
        showStripeModal.value = visible;
      }
    };

    const handleToggleAuthorizeNet = (visible: boolean) => {
      if (authorizeNetIntegration.value && !!document.value.value) {
        showSigningModal.value = false;
        showAuthorizeNetModal.value = visible;
      }
    };

    const trackVideo = async ({ id, viewDuration }: { id: string; viewDuration: number }) => {
      if (trackingDisabled.value) {
        return;
      }
      try {
        await TrackingService.trackVideo(id, viewDuration);
      } catch (_) {
        console.log(`Failed to track video with id ${id}`);
      }
    };

    const handleAttachmentView = (id: string) => {
      documentStore.setAttachmentView(id);
    };

    const toggleReject = (open: boolean) => {
      showRejectModal.value = open;
    };

    const handleToggleSigningModal = (open: boolean) => {
      if (waitingToShowReviewModal.value) {
        handleShowReviewChangesModal();
        return;
      }
      showSigningModal.value = open;
    };

    const handleToggleApproveModal = (open: boolean) => {
      showApproveModal.value = open;
    };

    const handleToggleInviteModal = (open: boolean) => {
      showInviteModal.value = open;
      if (!open) {
        documentStore.setForwardStatus(false);
      }
    };

    const handleApproveDocument = () => {
      actionApproveDocument();
    };

    const handleInviteRecipient = (recipientInfo: InviteRecipientInfo) => {
      documentStore.forwardToRecipient(recipientInfo, recipientId.value, authId.value);
    };

    const checkScrolledToBottom = () => {
      if (
        isPreview.value ||
        [RecipientStatus.Reviewed, RecipientStatus.Signed, RecipientStatus.Approved].includes(
          recipient.value.status
        )
      ) {
        return;
      }
      if (hasScrolledToBottom()) {
        handleUpdateRecipientStatus(RecipientStatus.Reviewed);
        window.removeEventListener('scroll', checkScrolledToBottom);
      }
    };

    const hasScrolledToBottom = () => {
      const scrollPosition: number = Math.ceil(window.scrollY);
      const windowHeight: number = window.innerHeight;
      const documentHeight: number = window.document.getElementById('document-content-container')
        .offsetHeight;
      return (
        SigningHelper.isFullDocumentHeightVisible(windowHeight, documentHeight) ||
        SigningHelper.hasScrolledToBottom(scrollPosition, windowHeight, documentHeight)
      );
    };

    const handleInitialsSubmit = (initials: string) => {
      addInitials({ initials, fieldId: selectedInitialFieldId.value });
    };

    const handleInitialsCancel = () => {
      setSelectedInitialFieldId('');
    };

    const handleClickInitialsField = (fieldId: string) => {
      if (!initials.value || isFieldVerified(fieldId)) {
        setSelectedInitialFieldId(fieldId);
        return;
      }
      fieldsStore.addVerifiedInitialId(fieldId);
    };

    const isFieldVerified = (fieldId: string) => verifiedInitialFieldIds.value.includes(fieldId);

    return {
      DocumentStatus,
      RecipientStatus,
      entity,
      toast,
      uploadAttachmentData,
      theme,
      recipient,
      stripeIntegration,
      authorizeNetIntegration,
      isSigningForward,
      document,
      isButtonLoading,
      forwarded,
      isDownloading,
      focusedRequiredId,
      nextRequiredId,
      showPhoneModal,
      selectedInitialFieldId,
      currentRecipient,
      trackingDisabled,
      comments,
      isChatOpen,
      chatSystemMessageOpen,
      commentingAllowed,
      pagesInViewport,
      hasContextualCommenting,
      allRecipients,
      currentRecipientsTurnToSign,
      documentName,
      senderFullName,
      showReviewChangesModal,
      reviewLoading,
      reviewPending,
      chatEnabled,
      showLoader,
      documentExtractable,
      showUploadAttachmentModal,
      isSigningEnabled,
      emptyBottomBar,
      showReject,
      activeTwilioIntegration,
      documentLogoUrl,
      token,
      showEngageVideo,
      videoUrl,
      sender,
      documentPages,
      manuallySignedPages,
      videoId,
      videoThumbnail,
      recipientsTurnToSign,
      showVideoReminder,
      reminderExpirationDays,
      showRevisionPromptBar,
      requiredStepsLeft,
      requiredIds,
      recipientPusherChannel,
      showRejectModal,
      pageImageLoaded,
      showBrowserPrompt,
      forcedReviewTimer,
      editorRecipientInput,
      getterVideoReminder,
      pageWidth,
      verifiedInitialFieldIds,
      sortedAttachments,
      viewportIsObscured,
      userIsInactive,
      canInvite,
      showRecipientsModal,
      showSigningModal,
      showInviteModal,
      showApproveModal,
      showStripeModal,
      showAuthorizeNetModal,
      shouldStartEid,
      loadingRecipientInput,
      commentsOpen,
      showDocumentUpdatedPromptBar,
      showPromptBar,
      classes,
      isXSmallScreenAndDown,
      isSmallScreenAndDown,
      isPreview,
      numUnreadComments,
      latestSealedRevision,
      partiallySignedFields,
      initials,
      authId,
      recipientId,
      shouldPopStripe,
      step,
      waitingToShowReviewModal,
      pusherConnected,
      documentManuallySigned,
      isAutoComment,
      interactionTimer,
      isEngageVideoOpen,
      isSignActionAllowed,
      stripe,
      hasFormInputFieldsWithErrors,
      t,
      handleReject,
      handleImageLoaded,
      handleToggleInviteModal,
      toggleShowVideoReminder,
      toggleReject,
      handleToggleChat,
      handleToggleUploadAttachmentModal,
      actionSetEditorRecipientInput,
      setToken,
      setDocumentStatus,
      setSessionStatus,
      handleToggleSigningModal,
      handleToggleApproveModal,
      handleInitialsSubmit,
      handleInitialsCancel,
      handleClickInitialsField,
      hasScrolledToBottom,
      handleApproveDocument,
      handleInviteRecipient,
      setPreviewExpired,
      actionCancelBankIdTransaction,
      handleToggleStripe,
      handleToggleAuthorizeNet,
      handleReviewChanges,
      handlePartiallySign,
      handleShowReviewChangesModal,
      trackVideo,
      handleAttachmentView,
      handleUpdateFocusedRequiredId,
      handleClickSignField,
      trackNodeClick,
      handleVideoIntro,
      handleCurrentPages,
      handleUpdateField,
      handleUpdatePageWidth,
      handleAttachmentUploaded,
      handleCloseSystemMessage,
      handleReload,
      sendMessage,
      hideBrowserPrompt,
      handleOpenRecipients,
      handleOpenPhoneModal,
      handleClosePhoneModal,
      handleCloseEngageVideo,
      handleDownloadDocument,
      handlePrint,
      subscribePusher,
      updateDocumentRevisions,
      addPusherSubscriptions,
      setForcedReviewTimer,
      startForcedReviewTimer,
      handleNewRevisionPushed,
      isRequiredField,
      isInvalidFieldValue,
      toggleTracking,
      automaticChatMessage,
      handleWatchNumUnreadComments,
      printDocument,
      printPrompt,
      handleUpdateDocumentStatus,
      resetInteractionTimer,
      openEngageVideoAutomatic,
    };
  },
});
